import { render, staticRenderFns } from "./OsSurveyQuestion.vue?vue&type=template&id=86deb3ae&scoped=true"
import script from "./OsSurveyQuestion.vue?vue&type=script&lang=ts"
export * from "./OsSurveyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./OsSurveyQuestion.vue?vue&type=style&index=0&id=86deb3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86deb3ae",
  null
  
)

export default component.exports